// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M8.4,7.3L7.7,6.6L12,2.3l4.3,4.3l-0.7,0.7l-3.1-3.1v9.3h-1V4.2L8.4,7.3z M19,12v7.5c0,0.3-0.2,0.5-0.5,0.5h-13
		C5.2,20,5,19.8,5,19.5V12H4v7.5C4,20.3,4.7,21,5.5,21h13c0.8,0,1.5-0.7,1.5-1.5V12H19z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-upload-CdyNmsJ7.js.map
